import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AccountPage } from './AccountPage';
import { DevicePage } from './DevicePage';
import { LoginPage } from './LoginPage';
import { ReturnPage } from './ReturnPage';
import { SignupPage } from './SignupPage';

export function AuthRouter() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="signup" element={<SignupPage />} />
      <Route path="account" element={<AccountPage />} />
      <Route path="device" element={<DevicePage />} />
      <Route path="return" element={<ReturnPage />} />
      <Route path="*" element={<Navigate to="login" replace />} />
    </Routes>
  );
}
